import {
  AccessItem,
  AccessControl,
  SecurityGroupRequest,
} from '../../../api/types/securityGroup.types';

// Helper: recursively get only leaf nodes
const getLeafNodes = (nodes: any[] = []): AccessItem[] => {
  const leaves: AccessItem[] = [];

  const traverse = (items: any[]) => {
    items.forEach((node) => {
      if (!node.children || node.children.length === 0) {
        leaves.push({
          id: node.id,
          isLocked: node.isLocked ?? false,
        });
      } else {
        traverse(node.children);
      }
    });
  };

  traverse(nodes);
  return leaves;
};

// Convert allRightData into a typed SecurityGroupRequest
export const convertToAccessControlRequest = (
  allRightData: Record<string, any>,
  securityGroupID: number,
  securityGroupName: string,
  isSecurityGroupLevel: boolean
): SecurityGroupRequest => {
  const accessControl = new AccessControl({
    commentList: getLeafNodes(allRightData.Comments),
    keyWordList: getLeafNodes(allRightData.Keywords),
    folderList: getLeafNodes(allRightData.Folders),
    tagList: getLeafNodes(allRightData.Tags),
    annotationList: getLeafNodes(allRightData['Annotation Layers']),
    productionsList: [], // left empty intentionally
    projectFieldsList: getLeafNodes(allRightData['Project Fields']),
    redactionList: getLeafNodes(allRightData['Redaction Tags']),
    assignmentList: [],
    calModelsToDelete: [],
  });

  return new SecurityGroupRequest({
    securityGroupID,
    securityGroupName,
    accessControl,
    isSecurityGroupLevel, // <-- use the passed value here
  });
};
